module.exports = __webpack_public_path__ + "static/media/UI flow sketches.4074d64f.png";